import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { Menu, Shield } from "lucide-react";
import AdminSidebar from "./AdminSidebar";
import logo from "@/assets/pk-logo.png";

export default function AdminLayout() {
  const [open, setOpen] = useState(false);
  return (
    <div className="flex h-screen overflow-hidden bg-slate-50 dark:bg-[#0F0D24]">
      <AdminSidebar open={open} onClose={() => setOpen(false)} />
      <div className="flex-1 flex flex-col overflow-hidden">
        <header className="h-14 border-b bg-white dark:bg-[#15122E] dark:border-white/10 flex items-center gap-3 px-4">
          <button className="lg:hidden" onClick={() => setOpen(true)} data-testid="admin-menu"><Menu className="w-5 h-5" /></button>
          <span className="inline-flex items-center gap-1.5 text-xs font-bold px-2 py-1 rounded-md text-white" style={{ background: "#7C3AED" }}><Shield className="w-3.5 h-3.5" /> ADMIN</span>
          <img src={logo} alt="Parth Kalyani" className="h-7 w-auto hidden sm:block" />
          <div className="text-sm text-slate-400">Platform Console</div>
        </header>
        <main className="flex-1 overflow-y-auto p-4 lg:p-6 xl:p-8">
          <div className="max-w-[1500px] mx-auto w-full animate-fade-up"><Outlet /></div>
        </main>
      </div>
    </div>
  );
}
